import React, {useState} from "react";
import {Input, Select, Form} from "antd";
import CorporateFormCSS from "./CorporateForm.module.scss";
// import ValidationMessage from "components/ValidationMessage/ValidationMessage";
import {InfoCircleOutlined} from "@ant-design/icons";
// import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";
// import { Popover , Button } from "antd";
import {
  errorToast,
  getErrorObject,
  successToast,
  verifyObject,
} from "utilities/utils";
import {ValidateCorporateInput} from "./ValidateCorporateForm";
import {addCorporateFrom} from "services/CorporateForm";
import FloatLabel from "components/common/FloatLabel";

const {Option} = Select;

const {TextArea} = Input;

// const password_info = (
//   <div className="forgot_wrapper">
//     <p className="m-0 font-13 weight-400">
//       Password should be atleast 8 characters including a number,an
//       uppercase,one special character and lowercase letter
//     </p>
//   </div>
// );

// const mobilenumber = (
//   <div className="forgot_wrapper">
//     <p className="m-0 font-13 weight-400">Mobile no should be of 10 digit</p>
//   </div>
// );

export default function CorporateFormContainer(props) {
  const [state, setState] = useState({
    first_name: "",
    last_name: "",
    password: "",
    confirm_password: "",
    no_of_employee: "",
    company_name: "",
    email: "",
    phone: null,
    country_code: "+44",
    position: "",
    message: "",
    business_type: "",
  });
  const params = new URLSearchParams(window.location.search); // id=123
  let plan_id = params.get("plan_id");
  console.log("plab", plan_id);

  const handleChange = (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
      errors: {
        [e.target.name]: null,
      },
    });
  };

  const _handleSubmit = async (e) => {
    e.preventDefault();
    let data = {
      first_name: state.first_name,
      last_name: state.last_name,
      email: state.email,
      phone: state.phone ? state.phone : "",
      no_of_employee: state.no_of_employee,
      company_name: state.company_name,
      position: state.position,
      message: state.message,
      business_type: "addv_minds",
    };
    const errors = ValidateCorporateInput(data);

    if (!errors.isValid) {
      setState({...state, errors: errors.errors, submitting: false});
    } else {
      const payload = {
        business_partner: {
          first_name: state.first_name,
          last_name: state.last_name,
          email: state.email,
          phone: state.phone ? `${state.country_code}${state.phone}` : "",
          no_of_employee: state.no_of_employee,
          company_name: state.company_name,
          position: state.position,
          message: state.message,
          business_type: "addv_minds",
        },
      };
      try {
        // let phone = JSON.parse(localStorage.getItem("otp-phone"));
        await setState({...state, loading: true});
        let response = await addCorporateFrom(payload);
        props.handleModalOPen(true);
        console.log("USER", response);
        successToast({
          content: verifyObject(response, "data.message", "Success"),
        });
        setState({
          first_name: "",
          last_name: "",
          password: "",
          confirm_password: "",
          no_of_employee: "",
          company_name: "",
          email: "",
          phone: "",
          country_code: "+44",
          position: "",
          message: "",
          business_type: "",
          isLoading: false,
          loading: false,
        });
        // navigateTo(`${appRoutesConst.index}?tab=plan`);
        // if (props.tabChange && typeof props.tabChange === "function") {
        //   props.tabChange("plan");
        // }
        // if (response.data.message) {
        // }
      } catch (error) {
        const {message} = getErrorObject(error);
        errorToast({content: message});
        setState({...state, loading: false});
      }
    }
  };

  // const [passwordVisible, setPasswordVisibe] = useState(false);

  // const togglePasswordVisiblity = () => {
  //   setPasswordVisibe(!passwordVisible);
  // };

  return (
    <div className={CorporateFormCSS.corporate_form}>
      <h2 className={CorporateFormCSS.form_header}>Corporate</h2>
      <div className={CorporateFormCSS.corporate_fields}>
        <form onSubmit={_handleSubmit}>
          <Form.Item className="margin-bottom-15">
            <div className="form-row">
              <div className="col-md-6">
                <FloatLabel
                  label="First Name"
                  value={state.first_name}
                  name="first_name"
                >
                  <Input
                    className={`form-control ${
                      state.errors && state.errors.first_name && "danger-border"
                    }`}
                    name="first_name"
                    value={state.first_name}
                    onChange={handleChange}
                    //placeholder="Enter first name"
                  />
                </FloatLabel>
                {state.errors && (
                  <span className="validate-danger">
                    {state.errors.first_name}
                  </span>
                )}
              </div>
              <div className="col-md-6">
                <FloatLabel
                  label="Last Name"
                  value={state.last_name}
                  name="last_name"
                >
                  <Input
                    className={`form-control ${
                      state.errors && state.errors.last_name && "danger-border"
                    }`}
                    name="last_name"
                    value={state.last_name}
                    onChange={handleChange}
                    //placeholder="Enter last name"
                  />
                </FloatLabel>
                {state.errors && (
                  <span className="validate-danger">
                    {state.errors.last_name}
                  </span>
                )}
              </div>
            </div>
          </Form.Item>
          <Form.Item className="margin-bottom-15">
            <div className="row">
              <div className="col-md-12">
                <FloatLabel
                  label="Email Address"
                  value={state.email}
                  name="email"
                >
                  <Input
                    className={`form-control ${
                      state.errors && state.errors.email && "danger-border"
                    }`}
                    name="email"
                    value={state.email}
                    onChange={handleChange}
                    //placeholder="Enter email address"
                  />
                </FloatLabel>
                {state.errors && (
                  <span className="validate-danger">{state.errors.email}</span>
                )}
              </div>
            </div>
          </Form.Item>

          <Form.Item className="margin-bottom-15 mobile_number_item">
            <div className="form-row">
              <div className="col-md-6">
                {/* <label
                  for="sel1"
                  className="font-12 text-default-color margin-bottom-10 weight-400 line-1 dis-block"
                >
                  Mobile Number
                  <Popover
                    content={mobilenumber}
                    placement="right"
                    className="infowrapper"
                  >
                    <Button className="noborder no-background p-0 line-1-imp height-auto-imp push-8-l">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="12"
                        height="12"
                        viewBox="0 0 12 12"
                      >
                        <g fill="none" fillRule="evenodd">
                          <g fill="#16A4FA" fillRule="nonzero">
                            <g>
                              <g>
                                <path
                                  d="M6.5 3c0 .276-.224.5-.5.5s-.5-.224-.5-.5.224-.5.5-.5.5.224.5.5zM6 9.5c-.207 0-.375-.168-.375-.375V5.25h-.5c-.207 0-.375-.168-.375-.375s.168-.375.375-.375H6c.207 0 .375.168.375.375v4.25c0 .207-.168.375-.375.375z"
                                  transform="translate(-329 -442) translate(215 442) translate(114)"
                                />
                                <path
                                  d="M6 12c-3.309 0-6-2.691-6-6s2.691-6 6-6 6 2.691 6 6-2.691 6-6 6zM6 .75C3.105.75.75 3.105.75 6S3.105 11.25 6 11.25 11.25 8.895 11.25 6 8.895.75 6 .75z"
                                  transform="translate(-329 -442) translate(215 442) translate(114)"
                                />
                                <path
                                  d="M7.125 9.5h-2.25c-.207 0-.375-.168-.375-.375s.168-.375.375-.375h2.25c.207 0 .375.168.375.375s-.168.375-.375.375z"
                                  transform="translate(-329 -442) translate(215 442) translate(114)"
                                />
                              </g>
                            </g>
                          </g>
                        </g>
                      </svg>
                    </Button>
                  </Popover>
                </label> */}

                <div className="mobnumber_wrapper">
                  <Select
                    className="custom-arrow"
                    value={state.country_code}
                    name="country_code"
                    onChange={(val) =>
                      handleChange({
                        target: {name: "country_code", value: val},
                      })
                    }
                  >
                    <Option value="+44">+44</Option>
                    <Option value="+91">+91</Option>
                  </Select>
                  <FloatLabel
                    label="Mobile number"
                    value={state.phone}
                    name="phone"
                  >
                    <input
                      type="text"
                      name="phone"
                      value={state.phone}
                      onChange={handleChange}
                      //placeholder="Enter Mobile Number"
                      className={`form-control ${
                        state.errors && state.errors.phone && "danger-border"
                      }`}
                    />
                  </FloatLabel>
                </div>
                {state.errors && (
                  <span className="validate-danger">{state.errors.phone}</span>
                )}
                {(state.phone === null || state.phone.length > 10) && (
                  <div className="info-icon">
                    <p className="font-12 weight-400 text-yellow margin-top-5 margin-bottom-0">
                      <InfoCircleOutlined className="vertical-middle" /> Mobile
                      no should be of 10 digit
                    </p>
                  </div>
                )}
              </div>
              <div className="col-md-6">
                <FloatLabel
                  label="No of Employee"
                  value={state.no_of_employee}
                  name="no_of_employee"
                >
                  <Input
                    className={`form-control ${
                      state.errors &&
                      state.errors.no_of_employee &&
                      "danger-border"
                    }`}
                    name="no_of_employee"
                    value={state.no_of_employee}
                    onChange={handleChange}
                    //placeholder="Enter no of employee"
                  />
                </FloatLabel>
                {state.errors && (
                  <span className="validate-danger">
                    {state.errors.no_of_employee}
                  </span>
                )}
              </div>
            </div>
          </Form.Item>
          <Form.Item className="margin-bottom-15">
            <div className="form-row">
              <div className="col-md-6">
                <FloatLabel
                  label="Company Name"
                  value={state.company_name}
                  name="company_name"
                >
                  <Input
                    className={`form-control ${
                      state.errors &&
                      state.errors.company_name &&
                      "danger-border"
                    }`}
                    name="company_name"
                    value={state.company_name}
                    onChange={handleChange}
                    //placeholder="Enter company name"
                  />
                </FloatLabel>
                {state.errors && (
                  <span className="validate-danger">
                    {state.errors.company_name}
                  </span>
                )}
              </div>
              <div className="col-md-6">
                <FloatLabel
                  label="Position"
                  value={state.position}
                  name="position"
                >
                  <Input
                    className={`form-control ${
                      state.errors && state.errors.position && "danger-border"
                    }`}
                    name="position"
                    value={state.position}
                    onChange={handleChange}
                    //placeholder="Enter position"
                  />
                </FloatLabel>
                {state.errors && (
                  <span className="validate-danger">
                    {state.errors.position}
                  </span>
                )}
              </div>
            </div>
          </Form.Item>
          <Form.Item className="margin-bottom-15">
            <div className="form-row">
              <div className="col-md-12">
                <FloatLabel
                  label="Message"
                  value={state.message}
                  name="message"
                >
                  <TextArea
                    className={`form-control ${
                      state.errors && state.errors.message && "danger-border"
                    }`}
                    name="message"
                    value={state.message}
                    onChange={handleChange}
                    autoSize={{minRows: 2, maxRows: 12}}
                    //placeholder="Enter message"
                  />
                </FloatLabel>
                {state.errors && (
                  <span className="validate-danger">
                    {state.errors.message}
                  </span>
                )}
              </div>
            </div>
          </Form.Item>
          <Form.Item>
            <button
              onClick={_handleSubmit}
              type="submit"
              disabled={state.loading}
              className={`${"btn-primary"} btn large-btn d-inline-block width-40`}
            >
              {state.loading ? <span>Submitting ...</span> : "Submit"}
            </button>
          </Form.Item>
        </form>
      </div>
    </div>
  );
}
